<template>
  <div class="admin-table-wrapper">
    <b-row class="top-buttons">
      <b-col>
        <slot name="top-buttons" />
        <b-button v-if="!config.hide_action_new_button &&
          config.use_new_modal &&
          config.auth_feature &&
          $store.getters['auth/isAuthorized'](config.auth_feature + '_new')
          " class="float-right mb-35" variant="outline-primary" size="lg" @click="openFormModal()">
          Nouveau
          <i class="far fa-plus ml-10"></i>
        </b-button>
        <b-button v-else-if="!config.hide_action_new_button &&
          config.auth_feature &&
          $store.getters['auth/isAuthorized'](config.auth_feature + '_new')
          " class="float-right mb-35" variant="outline-primary" size="lg" :to="{ name: config.new_route_name }">
          Nouveau
          <i class="far fa-plus ml-10"></i>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div v-if="tab_filter" class="tabs d-flex flex-row" ref="tabs">
          <div :class="{ tab: true, active: !tab_filter_default_value }" @click="setTab($event, null)">
            Tout
          </div>
          <div v-for="option in options[tab_filter.name + '_options']" :key="option.value" :ref="'tab_' + option.value"
            @click="setTab($event, option.value)" :class="{
              tab: true,
              active: option.value == tab_filter_default_value,
            }">
            {{ option.text }}
          </div>
        </div>

        <div class="ibox">
          <div class="ibox-content">
            <div class="filters">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1 search-bar">
                  <b-form-group inline class="mb-0">
                    <b-input-group>
                      <label class="mb-0 align-self-center">
                        <i class="far fa-search fa-lg"></i>
                      </label>
                      <b-form-input v-model="filter" placeholder="Rechercher" />
                      <b-input-group-append v-if="filter &&
                        (!this.config.show_extended_filters ||
                          this.config.show_extended_filters !== true)
                        ">
                        <b-button :disabled="!filter" @click="filter = ''">
                          <i class="far fa-times"></i>
                        </b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </div>
                <div class="ml-2 filters-toggle" v-if="extended_filters.length &&
                  (!this.config.show_extended_filters || this.config.show_extended_filters !== true)
                  " @click.prevent="toggleExtendedFilters()">
                  <a href v-if="extended_filters_is_open">
                    Moins d'options
                    <i class="fa fa-chevron-up ml-1"></i>
                  </a>
                  <a href v-else>
                    Plus d'options
                    <i class="fa fa-chevron-down ml-1"></i>
                  </a>
                </div>
                <div class="ml-2 filters-toggle" v-else @click.prevent="resetFilters()">
                  <a href>
                    Reset
                    <i class="fa fa-undo ml-1"></i>
                  </a>
                </div>
              </div>
              <b-form v-if="extended_filters.length && extended_filters_is_open">
                <b-row>
                  <b-col v-for="extended_filter in extended_filters" :key="extended_filter.name" class="filter-col">
                    <b-form-group :label="extended_filter.label + ' :'" :label-for="'filter-' + extended_filter.name">
                      <b-form-select :id="'filter-' + extended_filter.name" v-if="extended_filter.type == 'select'"
                        v-model="extended_filters_model[extended_filter.name]"
                        :options="options[extended_filter.name + '_options']">
                        <!-- This slot appears above the options from 'options' prop -->
                        <template slot="first">
                          <option :value="null">-- Tout --</option>
                        </template>
                      </b-form-select>
                      <Chosen :id="'filter-' + extended_filter.name" v-if="extended_filter.type == 'chosen'"
                        v-model="extended_filters_model[extended_filter.name]"
                        :options="options[extended_filter.name + '_options']" allowAll="true" label="text" trackBy="value"
                        searchContains="true"></Chosen>
                      <div v-if="extended_filter.type == 'date'" class="d-flex">
                        <datepicker :id="'filter-' + extended_filter.name" input-class="form-control"
                          v-model="extended_filters_model[extended_filter.name]['start']" :format="'dd/MM/yyyy'"
                          :monday-first="true" :language="fr" :clear-button="true" clear-button-icon="fa fa-times fa-lg">
                        </datepicker>
                        <div class="align-self-center ml-1 mr-1">Au</div>
                        <datepicker :id="'filter-' + extended_filter.name + '-2'" input-class="form-control"
                          v-model="extended_filters_model[extended_filter.name]['end']" :format="'dd/MM/yyyy'"
                          :monday-first="true" :language="fr" :clear-button="true" clear-button-icon="fa fa-times fa-lg">
                        </datepicker>
                      </div>
                      <b-form-input v-if="extended_filter.type == 'text'" class="flex-fill"
                        :id="'filter-' + extended_filter.name" type="text"
                        v-model="extended_filters_model[extended_filter.name]" />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </div>

            <b-row class="mt-4">
              <b-col>
                <div class="d-flex align-items-center">
                  <b-form-checkbox v-if="!config.hide_action_csv_button && totalRows" class="select-all"
                    v-model="allSelected" :value="true" :unchecked-value="false" @change="toggleSelectAll">
                    Tout sélectionner
                  </b-form-checkbox>
                  <b-form inline class="ml-auto">
                    <download-csv v-if="!config.hide_action_csv_button && selectedRowsCount"
                      :class="['btn', 'btn--csv', selectedRowsCount == totalRows ? 'btn-primary' : null]"
                      :data="exportCsvRows" :fields="exportCsvFields" :labels="exportCsvLabels" :name="exportCsvFilename"
                      delimiter=";" ref="downloadCsv">{{
                        selectedRowsCount == totalRows
                        ? "Cliquez de nouveau pour tout exporter"
                        : "Exporter la sélection en CSV"
                      }} ({{ selectedRowsCount || totalRows }} lignes
                      sélectionnées)</download-csv>
                    <div v-else class="btn btn--csv" @click="prepareCsvExport()">Tout exporter en CSV ({{ totalRows }}
                      lignes
                      sélectionnées)</div>
                    <b-form-group class="mb-0 ml-10">
                      <b-input-group>
                        <b-form-select v-model="perPage" :options="perPageOptions" />
                      </b-input-group>
                    </b-form-group>
                  </b-form>
                </div>
              </b-col>
            </b-row>

            <div class="table-wrapper mt-2">
              <b-table ref="table" id="admin-table-sync" hover show-empty :fields="fields" :items="itemsProvider"
                :sort-by="config.sort_by || null" :sort-desc="config.sort_desc || false" :filter="filter"
                :current-page="currentPage" :per-page="parseInt(perPage)" :selectable="!config.hide_action_csv_button"
                :select-mode="'multi'" selectedVariant="info" @row-selected="rowSelected" :busy="isBusy">
                <div slot="table-busy" class="text-center my-2">
                  <div v-if="isBusy" class="loader"></div>
                  Les données sont en cours de chargement...
                </div>
                <template slot="empty" slot-scope="scope">
                  <div v-if="config.new_route_name" class="text-center mt-2">
                    Cette liste est vide pour le moment, soyez le premier à créer un enregistrement
                    <!-- <br>
                    <b-button
                      v-if="config.use_new_modal && config.auth_feature && $store.getters['auth/isAuthorized'](config.auth_feature+'_new')"
                      class="mt-2 mb-2"
                      variant="outline-primary"
                      size="lg"
                      @click="openFormModal()"
                    >
                      Nouveau
                      <i class="far fa-plus ml-10"></i>
                    </b-button>
                    <b-button
                      v-else-if="config.auth_feature && $store.getters['auth/isAuthorized'](config.auth_feature+'_new')"
                      class="mt-2 mb-2"
                      variant="outline-primary"
                      size="lg"
                      :to="{name:config.new_route_name}"
                    >Nouveau</b-button>-->
                  </div>
                  <div v-else class="text-center mt-2">Cette liste est vide pour le moment</div>
                </template>
                <template slot="emptyfiltered" slot-scope="scope">
                  <div class="text-center mt-2">Aucun résultat ne correspond à la recherche</div>
                </template>

                <template slot="select" slot-scope="data">
                  <b-form-checkbox :name="'select-' + data.item.id" :checked="data.rowSelected"
                    @change="toggleSelectRow(data.index + 1)"></b-form-checkbox>
                </template>
                <template v-for="field in config.fields.filter((field) => field.inList == true)" :slot="field.name"
                  slot-scope="data">
                  <b-badge v-if="field.type == 'yesno' && data.value == true" :key="field.name" variant="success"
                    class="circle float-left">
                    <i class="fa fa-check"></i>
                  </b-badge>
                  <b-badge v-else-if="field.type == 'yesno' && data.value == false" :key="field.name" variant="danger"
                    class="circle float-left">
                    <i class="fa fa-times"></i>
                  </b-badge>
                  <template v-else-if="field.type == 'date'">{{
                    data.value | moment("DD-MM-YYYY")
                  }}</template>
                  <slot v-else :name="field.name" :data="data">{{ data.value }}</slot>
                </template>

                <template :slot="config.title_field" slot-scope="data">
                  <router-link v-if="config.detail_route_name &&
                    config.auth_feature &&
                    $store.getters['auth/isAuthorized'](config.auth_feature + '_show')
                    " :to="{
    name: config.detail_route_name,
    params: { id: data.item.id },
  }">
                    <template v-if="config.fields.find((field) => field.name == config.title_field).type ==
                      'date'
                      ">{{ data.value | moment("DD-MM-YYYY") }}</template>
                    <template v-else>{{ data.value }}</template>
                  </router-link>
                  <template v-else>{{ data.value }}</template>
                </template>
                <template slot="actions" slot-scope="data">
                  <b-button-group size="sm" class="actions">
                    <slot name="actions" :data="data"></slot>
                    <b-button v-b-tooltip.hover title="Editer" variant="outline-secondary" v-if="config.use_edit_modal &&
                      !config.hide_action_edit_button &&
                      data.item.id &&
                      ((config.edit_condition && config.edit_condition(data.item)) ||
                        !config.edit_condition) &&
                      config.auth_feature &&
                      $store.getters['auth/isAuthorized'](config.auth_feature + '_edit')
                      " @click="openFormModal(data.item.id)">
                      <i class="far fa-pencil"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Editer" variant="outline-secondary" v-if="!config.use_edit_modal &&
                      !config.hide_action_edit_button &&
                      data.item.id &&
                      ((config.edit_condition && config.edit_condition(data.item)) ||
                        !config.edit_condition) &&
                      config.auth_feature &&
                      $store.getters['auth/isAuthorized'](config.auth_feature + '_edit')
                      " :to="{
    name: config.editRouteName,
    params: { id: data.item.id },
  }">
                      <i class="far fa-pencil"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Exporter en PDF" variant="outline-secondary"
                      v-if="!config.hide_action_pdf_button && data.item.id" @click.prevent="exportPdfSingle(data.item)">
                      <i class="far fa-file-alt"></i>
                    </b-button>
                    <b-button v-b-tooltip.hover title="Supprimer" variant="outline-secondary" v-if="!config.hide_action_delete_button &&
                      data.item.id &&
                      ((config.delete_condition && config.delete_condition(data.item)) ||
                        !config.delete_condition) &&
                      config.auth_feature &&
                      $store.getters['auth/isAuthorized'](config.auth_feature + '_delete')
                      " @click.prevent="deleteItem(data.item.id)">
                      <i class="far fa-trash-alt"></i>
                    </b-button>
                  </b-button-group>
                </template>
              </b-table>
            </div>

            <div class="total float-right">
              {{ resultsCount }} / <strong>{{ totalRows }}</strong> résultats
            </div>

            <b-pagination class="mb-0" align="center" size="sm" :total-rows="totalRows" :per-page="parseInt(perPage)"
              v-model="currentPage" />
          </div>
        </div>
      </b-col>
    </b-row>

    <AdminModalForm v-if="config.use_new_modal || config.use_edit_modal" :config="config" :id_to_edit="id_to_edit"
      @submit:create:success="submitCreateSuccess" @submit:update:success="submitUpdateSuccess"
      @submit:create:error="submitCreateError" @submit:update:error="submitUpdateError" />
  </div>
</template>

<script>
import AdminModalForm from "@/components/Global/AdminModalForm";
import Datepicker from "vuejs-datepicker";
import { en, fr } from "vuejs-datepicker/dist/locale";
import Chosen from "@/components/Global/Chosen";

export default {
  name: "AdminTable",
  components: {
    AdminModalForm,
    Datepicker,
    Chosen,
  },
  props: ["config", "options", "items_provider"],
  data() {
    return {
      totalRows: 0,
      resultsCount: 0,
      fields: [],
      currentPage: 1,
      perPage: 20,
      perPageOptions: {
        10: "10 par page",
        20: "20 par page",
        50: "50 par page",
        100: "100 par page",
        999999999: "Tout afficher", // On ne met pas une valeur vide car cela aurait pour conséquence de ne pas appliquer d'attribut aria-rowindex sur les lignes. Et on en a besoin pour l'usage des checkbox
      },
      allSelected: false,
      selectedRowsCount: 0,
      exportCsvFields: [],
      exportCsvLabels: {},
      exportCsvRows: [],
      exportCsvFilename:
        this.config.csv_export_filename_prefix + "-" + this.$moment().format("YYYY-MM-DD") + ".csv",
      isBusy: false,
      filter: null,
      extended_filters: [],
      extended_filters_model: {},
      extended_filters_is_open: this.config.show_extended_filters || false,
      tab_filter: null,
      tab_filter_default_value: null,
      id_to_edit: null,
      en: en,
      fr: fr,
    };
  },
  watch: {
    // Quand le champ de recherche change
    filter: {
      handler: function (newFiltersValues) {
        this.currentPage = 1;
      },
    },
    // Quand les filtres étendus changent
    extended_filters_model: {
      handler: function (newFiltersValues) {
        this.currentPage = 1;
        this.extentedFiltersFunction();
      },
      deep: true,
    },
  },
  mounted() {
    // On récupère la liste des filtres étendus (en plus du champ de recherche)
    this.extended_filters = this.config.fields.filter((field) => field.extended_filter == true);
    const extended_filters_model = {};
    this.extended_filters.forEach((filter) => {
      if (filter.type == "date") {
        extended_filters_model[filter.name] = {
          start: null,
          end: null,
        };
      } else {
        extended_filters_model[filter.name] = null;
      }
    });
    this.extended_filters_model = extended_filters_model;

    // On récupère le filtre par onglet, et on l'ajoute au model des filtres etendus
    this.tab_filter = this.config.fields.find((field) => field.tabFilter == true) || null;
    if (this.tab_filter && this.tab_filter) {
      extended_filters_model[this.tab_filter.name] = null;
      this.extended_filters_model = extended_filters_model;
    }

    // Valeur par défaut du filtre par onglet (si défini)
    if (this.tab_filter) {
      this.tab_filter_default_value = this.tab_filter.tabFilterDefaultValue || null;
      this.extended_filters_model[this.tab_filter.name] = this.tab_filter_default_value;
    }

    // Filtrage par url (peut aussi fonctionner pour le statut)
    if (this.$route.params.hasOwnProperty('defaultFilterField') && this.$route.params.hasOwnProperty('defaultFilsterValue') && this.extended_filters_model.hasOwnProperty(this.$route.params.defaultFilterField)) {
      this.extended_filters_model[this.$route.params.defaultFilterField] = this.$route.params.defaultFilsterValue;
    }

    // Chargement des champs à afficher dans la liste depuis la config pour les passer au composant AdminTable
    this.fields = this.config.fields
      .filter((field) => field.inList == true)
      .map((field) => ({
        key: field.name,
        label: field.label,
        sortable: field.sortable || false,
      }));

    // Si l'export CSV est activé, on ajoute une colonne avec checkbox pour la sélection des lignes
    if (!this.config.hide_action_csv_button) {
      this.fields.unshift({ key: "select", label: "" });
    }
    if (
      (!this.config.hide_action_edit_button &&
        this.config.auth_feature &&
        this.$store.getters["auth/isAuthorized"](this.config.auth_feature + "_edit")) ||
      !this.config.hide_action_pdf_button ||
      (!this.config.hide_action_delete_button &&
        this.config.auth_feature &&
        this.$store.getters["auth/isAuthorized"](this.config.auth_feature + "_delete")) ||
      this.$scopedSlots.actions
    ) {
      this.fields.push({ key: "actions", label: "Actions" });
    }

    // Chargement des champs à exporter en CSV depuis la config pour les passer au composant AdminTable
    this.exportCsvFields = this.config.fields
      .filter((field) => field.inCsvExport == true)
      .map((field) => field.name);
    this.config.fields
      .filter((field) => field.inCsvExport == true)
      .forEach((field) => {
        this.exportCsvLabels[field.name] = field.label;
      });

    this.$root.$on("refresh", this.extentedFiltersFunction);
  },
  methods: {
    /**
     * Gère l'apparition ou le masquage des filtres étendus
     */
    toggleExtendedFilters() {
      this.extended_filters_is_open = !this.extended_filters_is_open;

      // Si on ferme les filtres, on reset ceux-ci
      if (!this.extended_filters_is_open) {
        this.resetFilters();
      }
    },
    /**
     * Remise à zéro de tous les filtres
     */
    resetFilters() {
      this.filter = "";

      this.extended_filters.forEach((filter) => {
        if (filter.type == "date") {
          this.extended_filters_model[filter.name] = {
            start: null,
            end: null,
          };
        } else {
          this.extended_filters_model[filter.name] = null;
        }
      });
    },
    /**
     * Méthode appelée par b-table pour la récupération des données
     * https://bootstrap-vue.js.org/docs/components/table/#using-items-provider-functions
     * @param   {object}  ctx   Objet context envoyé par b-table
     * @returns {array}         Items à afficher
     */
    itemsProvider(ctx) {
      ctx = {
        ...ctx,
        extended_filters_model: this.extended_filters_model,
      };
      return this.items_provider(ctx)
        .then((payload) => {
          this.totalRows = payload.total;
          this.resultsCount = payload.items.length;
          return this.$root.formatDatas(
            payload.items,
            this.config.fields.filter((field) => field.inList == true),
            true
          );
        })
        .catch();
    },
    /**
     * Toggle la sélection de tous les items
     */
    toggleSelectAll() {
      if (!this.allSelected) {
        this.selectAll();
      } else {
        this.unselectAll();
      }
    },
    /**
     * Sélection de toutes les lignes
     */
    selectAll() {
      $(this.$refs.table.$el).find("tbody tr:not(.b-row-selected)").trigger("click");
    },
    /**
     * Désélection de toutes les lignes
     */
    unselectAll() {
      $(this.$refs.table.$el).find("tbody tr.b-row-selected").trigger("click");
    },
    /**
     * Toggle la sélection d'une ligne lorsque la checkbox est cochée ou décochée
     * @param {integer} index index de la ligne (commence à 1 pour la première ligne)
     */
    toggleSelectRow(index) {
      $(this.$refs.table.$el)
        .find("tbody tr[aria-rowindex='" + index + "']")
        .trigger("click");
    },
    /**
     * Prépare le téléchargement CSV pour le cas ou rien n'est sélectionné, alors on doit
     * tout télécharger et donc faire une requete au back au préalable
     */
    prepareCsvExport() {
      if (this.selectedRowsCount == 0) {
        let ctx = {
          currentPage: 1,
          perPage: 0,
          sortBy: this.config.sort_by || null,
          sortDesc: this.config.sort_desc ? "DESC" : "ASC",
          search: null,
          extended_filters_model: this.extended_filters_model,
        }
        this.items_provider(ctx)
          .then((payload) => {
            this.totalRows = payload.total;
            this.resultsCount = payload.items.length;
            this.rowSelected(payload.items)
            $(this.$refs.downloadCsv).trigger("click")
          })
      }
    },
    /**
     * Supprime un item (via le store)
     * @param {integer} id  Id de l'item à supprimer
     */
    deleteItem(id) {
      if (confirm("Êtes-vous sur de vouloir supprimer cet élément ?")) {
        this.$store
          .dispatch(this.config.store_namespace + "/deleteItem", id)
          .then((response) => {
            this.$emit("delete:success", response);
          })
          .catch((error) => {
            this.$emit("delete:error", error);
          });
      }
    },
    /**
     * Fonction de filtrage via les filtres étendus (inclus les onglets)
     */
    extentedFiltersFunction() {
      this.$refs.table.refresh();
    },
    /**
     * Callback appelé lorsqu'une ou des lignes sont sélectionnées
     * Prépare les données pour les exports CSV et PDF selon les lignes sélectionnées
     * @param   {array} rows  Tableau des lignes sélectionnées
     */
    rowSelected(rows) {
      // Dans le cas ou on sélectionne toutes les lignes on coche la checkbox "Sélectionner tout"
      // inversement, si on déselectionne une ligne, on décoche la checkbox "Sélectionner tout"
      this.allSelected =
        this.totalRows < this.perPage ? rows.length == this.totalRows : rows.length == this.perPage;

      this.selectedRowsCount = rows.length;

      var formattedRows = [];
      rows.forEach((row) => {
        formattedRows.push({
          ...row,
          ...this.$root.formatData(
            row,
            this.config.fields.filter(
              (field) => field.inCsvExport == true && (field.inList != true || field.type == "date")
            )
          ),
        });
      });

      this.exportCsvRows = formattedRows.map((row) => {
        let output = {};
        this.config.fields
          .filter((field) => field.inCsvExport == true)
          .forEach((field) => {
            output[field.name] =
              field.type == "yesno"
                ? row[field.name] == true
                  ? "Oui"
                  : "Non"
                : row[field.name] || null;
          });
        return output;
      });
    },
    /**
     * Sélectionne un filtre par onglet
     * La valeur de l'onget est ajoutée au filtres étendus afin de filtrer la liste courante
     * @param {string}  value valeur de l'onglet
     */
    setTab(e, value) {
      this.$refs.tabs.querySelector(".tab.active").classList.remove("active");
      e.target.classList.add("active");
      let new_extended_filters_model = { ...this.extended_filters_model };
      new_extended_filters_model[this.tab_filter.name] = value;
      this.extended_filters_model = new_extended_filters_model;
      this.$emit("setTab", value);
    },
    /**
     * Exporte en PDF une seule ligne (bouton sur la ligne)
     * Prépare les données pour les envoyer à la fonction globale exportPdf()
     * @param {integer} item  Item à exporter
     */
    exportPdfSingle(item) {
      this.$store
        .dispatch(this.config.store_namespace + "/getItem", {
          id: item.id,
          wait: true,
        })
        .then(() => {
          item = this.$store.getters[this.config.store_namespace + "/getItem"](item.id);

          let formattedItem = this.$root.formatData(
            item,
            this.config.fields.filter((field) => field.inPdfExport == true)
          );

          let exportPdfData = {
            title: this.config.pdf_export_title
              ? this.config.pdf_export_title(item, formattedItem, this)
              : item[this.config.title_field],
            link: this.config.pdf_export_link
              ? this.config.pdf_export_link(item, formattedItem, this)
              : null,
            infos: [],
          };

          if (this.config.pdf_export_logo) {
            exportPdfData.logo = this.config.pdf_export_logo;
          }

          if (this.config.pdf_export_extra_content_before) {
            exportPdfData.extra_content_before = this.config.pdf_export_extra_content_before(
              item,
              formattedItem,
              this
            );
          }

          if (this.config.pdf_export_custom_main_content) {
            exportPdfData.custom_main_content = this.config.pdf_export_custom_main_content(
              item,
              formattedItem,
              this
            );
          } else {
            this.config.fields
              .filter((field) => field.inPdfExport == true)
              .forEach((field) => {
                exportPdfData.infos.push([
                  field.label + " :",
                  field.type == "yesno"
                    ? formattedItem[field.name] == true
                      ? "Oui"
                      : "Non"
                    : formattedItem[field.name] || null,
                ]);
              });
          }

          let lists = this.config.fields.filter((field) => field.type == "list");
          exportPdfData.lists = [];
          if (lists && lists.length) {
            lists.forEach((list) => {
              let currentList = {
                label: list.label,
                infos: [
                  list.fields.map((field) => list.config.fields.find((f) => f.name == field).label),
                ],
              };

              if (item[list.name]) {
                this.$root
                  .formatDatas(
                    item[list.name],
                    list.config.fields.filter((field) => field.inPdfExport == true)
                  )
                  .forEach((item) => {
                    let infosItem = [];
                    list.fields.forEach((field) => {
                      infosItem.push(item[field] || null);
                    });
                    currentList.infos.push(infosItem);
                  });
              }

              exportPdfData.lists.push(currentList);
            });
          }

          if (this.config.pdf_export_extra_lists) {
            exportPdfData.lists.push(
              ...this.config.pdf_export_extra_lists(item, formattedItem, this)
            );
          }

          if (this.config.pdf_export_extra_content_after) {
            exportPdfData.extra_content_after = this.config.pdf_export_extra_content_after(
              item,
              formattedItem,
              this
            );
          }

          this.$root.exportPdf(exportPdfData);
        });
    },
    openFormModal(id) {
      this.id_to_edit = id;
      this.$root.$emit("bv::show::modal", "admin_modal_form");
    },
    submitCreateSuccess(response) {
      this.$emit("submit:create:success", response);
    },
    submitUpdateSuccess(response) {
      this.$emit("submit:update:success", response);
    },
    submitCreateError(error) {
      this.$emit("submit:create:error", error);
    },
    submitUpdateError(error) {
      this.$emit("submit:update:error", error);
    },
    refresh() {
      this.$root.$emit('bv::refresh::table', 'admin-table-sync');
    },
  },
};

function resolve(obj, path) {
  path = path.split(".");
  var current = obj;
  while (path.length) {
    if (typeof current !== "object") return undefined;
    current = current[path.shift()];
  }
  return current;
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/_colors.scss";

.filters {
  border: solid 1px lightgrey;
  padding: 6px 20px;
  border-radius: 0;

  .search-bar {
    input {
      border: none;
      font-size: 12px;
      outline: none;
      box-shadow: none;
    }

    button.btn {
      color: inherit;
      background: none;
      border: none;
    }
  }

  .filters-toggle a {
    font-size: 12px;
  }

  form {
    margin-top: 10px;
  }
}

.tabs {
  background-color: $color2;
  width: 100%;
  border-radius: 15px 15px 0 0;
  overflow: hidden;

  .tab {
    padding: 15px 20px;
    text-align: center;
    text-transform: uppercase;
    color: $color1;
    font-size: 13px;
    opacity: 0.5;
    cursor: pointer;

    &.active {
      color: $color2;
      opacity: 1;
      background-color: #fff;
      border-radius: 15px 15px 0 0;
      box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
    }
  }
}
</style>

<style lang="scss">
@import "~@/assets/scss/_colors.scss";

.table {
  margin-top: 20px;

  tr {
    &:first-of-type {
      td {
        border-top: none;
      }
    }

    th {
      border: none;
    }

    td,
    th {
      font-size: 13px !important;

      &:first-of-type {
        width: 10px;
        padding: 0.75rem 0;
      }

      &:last-of-type {
        text-align: right;
      }
    }
  }

  &--order {
    tr {

      td,
      th {
        &:last-of-type {
          text-align: left;
        }
      }
    }
  }
}

.form-group {
  label {
    font-size: 13px;
    font-family: 'ClanFFBlack';
  }

  .custom-select {
    font-size: 12px;
  }
}

.btn-outline-primary {
  font-size: 12px;
  margin-bottom: 20px;
}

.btn {
  &--csv {
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    padding: 0 10px;
    border: 1px solid lightgrey;
    margin-right: 10px;
    cursor: pointer;
  }
}

.custom-control-label {
  padding-top: 3px;
}

.select-all {
  font-size: 12px;
  text-decoration: underline;
}

.input-group-append {
  height: 32px;
  margin-left: 0;
}

a {
  color: $color4;
}

.pagination {
  .page-item {
    .page-link {
      border: none;
      color: $color1;
    }

    &.active {
      .page-link {
        background-color: $color1;
        color: white;
      }
    }
  }
}

.btn-add {
  background-color: $color1;
  color: white;
  border: none;
  position: absolute;
  right: 0;
  bottom: 20px;
  margin-bottom: 0;

  &:hover {
    background-color: $color2;
  }
}

.row {
  width: 100%;
  margin: 0;

  .col {
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Global/AdminTableSync.vue